import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Radio } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    const clearHash = () => window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      clearHash();
      setUser(false);
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        clearHash();
        setUser(data);
        const n = data?.claimed_reports || 0;
        if (n > 0) {
          toast.success(`${n} phone report${n > 1 ? "s" : ""} from your number ${n > 1 ? "were" : "was"} attached to your account`);
        }
        navigate("/", { replace: true });
      })
      .catch(() => {
        clearHash();
        setUser(false);
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback-loading">
      <div className="flex items-center gap-2 text-muted-foreground animate-pulse">
        <Radio className="w-5 h-5 text-[#007AFF]" />
        <span className="font-mono text-sm">Signing you in…</span>
      </div>
    </div>
  );
}
